export enum VOTE_OPTIONS {
  YES = 'YES',
  NO = 'NO',
  NO_INFO = 'NO_INFO',
}
